import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/entity-views',
        transform: Transforms.list,
    },
    create: {
        method: 'POST',
        path: '/entity-views',
        transform: Transforms.create,
    },
    get: {
        path: '/entity-views/:id',
        transform: Transforms.get,
    },
    update: {
        method: 'PATCH',
        path: '/entity-views/:id',
    },
    remove: {
        method: 'DELETE',
        path: '/entity-views/:id',
    },
}

export default {
    name: 'views',
    endpoints,
}
